import NavigableValidation from "./navigableValidation";
import NavigableValidator from "../navigableValidators/navigableValidator";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import { IErrorNavOpts } from "~/models/validationError";
import { ValidationModalSection } from "~/models/navigableValidations/validationSections";
import ObjectModelLimit from "../objectModelLimit";

export default class ObjectModelLimitValidation extends NavigableValidation<ObjectModelLimit> {
  model: ObjectModelLimit;
  validators: NavigableValidator<ObjectModelLimit>[] = [
    new FieldPresenceValidator({
      validatorKey: 'maximum',
      section: ValidationModalSection.Settings
    }),
    new FieldPresenceValidator({
      validatorKey: 'title',
      section: ValidationModalSection.Settings
    })
  ];

  errorNavOpts(validator, field: string, value?): IErrorNavOpts {
    let base = super.errorNavOpts(validator, field, value)
    const index = Object.keys(this.model.parent.object_model_limits).findIndex(key => key === this.model.client_id)
    Object.assign(base, {
      query: { selectedId: this.model.client_id },
      targetElementId: this.model.idForProp(field),
      hash: `${field}_${index}`
    });
    return base;
  }
}